export default "__VITE_ASSET__e122c8e4__"